export enum DepartmentActionTypes {
    API_RESPONSE_SUCCESS = '@@department/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@department/API_RESPONSE_ERROR',

    GET_DEPARTMENT = '@@department/GET_DEPARTMENT',
    RESET = '@@department/RESET',
    RESET_SUCCESS = '@@department/RESET_SUCCESS',
    RESET_ERROR = '@@department/RESET_ERROR',
}
